import { FormsService } from '@/service/FormsService'
import Model from './Model'
export enum AnswerType {
  TEXT_BOX = 'TEXT_BOX',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTIPLE_SELECT = 'MULTIPLE_SELECT',
}
export interface IFormQuestion {
  answerType: AnswerType
  question: string
  answerOptions: string[]
}

export interface IForms {
  locationId: string
  groupId: string
  questions: IFormQuestion[]
}
export default class Forms extends Model {
  constructor(payload: IForms) {
    super(payload, FormsService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get groupId(): string {
    return this._data.groupId
  }

  set groupId(groupId: string) {
    this._data.groupId = groupId
  }

  get questions(): IFormQuestion[] {
    return this._data.questions
  }

  set questions(questions: IFormQuestion[]) {
    this._data.questions = questions
  }
}
